module.exports = __webpack_public_path__ + "img/integrations.6a518aa6.png";